const XColors = {
    primaryColor: '#9490ff',
    secondaryColor: '#d7d6ff',
    tertiaryColor: '#f4f4ff',
    backgroundColor: '#202020',
    lightGray: '#444444',
    hoverColor: '#444444',
    textColor: '#4A4880',
    languageSwitcherActiveColor: '#A9A6FF',
    languageSwitcherInactiveColor: '#D7D6FF',
    buttonBackgroundColor: '#9490FF',
    white: '#FFFFFF',
    white2: '#F4F4FF',
    lightYellow: '#ffefdd',
    secondaryTextColor: '#6C6C6C',
    green: '#54b54a',
    red: '#cf3530',
    secondaryRed: '#E03F1B',
    error: 'transparent',
    errorBorder: '#ffc83a',
    darkGray: '#666666',
    midGray: '#333333',
    black: '#000000',
    basicGray: '#808080',
    disabledGray: '#999999',
    tintGreen: '#52CE8B',
    lbBlue: '#236092',
}

export default XColors
